/* eslint-disable react-hooks/exhaustive-deps */
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, InputBase, MenuItem, MenuList, Paper, Radio, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import * as PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { addSkipIndex, getCountriesData, removeSkipIndex, showMessageBar } from "../../../../../store/actions";
import { ExpandMore, RadioButtonChecked } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { MESSAGE_BAR_TYPES, ACTIVITY_DETAIL, EVENTS, screenHeightPercentagesCurrency } from "../../../../../utils/constants";
import AppScreenLoader from "../../../../../components/AppScreenLoader";
import { getCurrencyListFiat, getMassPayPaymentMethods, massPayCreateUser, logEvent } from "../../../../../store/api";
import AppButton from '../../../../../components/AppButton';
import { useLocation } from "react-router-dom";

export default function CountrySelect({ setActive, active, country, setCountry, amount,
    setPaymentMethod, setDestinationId, setPaymentCurrency, setPaymentPayer }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const countries = useSelector(({ transfer }) => transfer.countries);
    const defaultCountry = useSelector(({ transfer }) => transfer.defaultCountry);
    const [filteredCountries, setFilteredCountries] = useState(countries);
    const location = useLocation();
    useEffect(() => {
        dispatch(getCountriesData());
    }, []);
    const getHeight = () => {
        return (
            window.innerHeight -
            (window.innerHeight * screenHeightPercentagesCurrency(window.innerHeight)) / 100
        );
    };
    const [height, setHeight] = useState(getHeight());
    useEffect(() => {
        window.addEventListener("resize", () => {
            setHeight(getHeight());
        });
        return () => window.removeEventListener("resize", () => { });
    }, []);
    useEffect(() => {
        if (search) {
            const filtered = countries.filter(val => val?.name?.toLowerCase().includes(search?.toLowerCase()));
            setFilteredCountries(filtered);
        } else {
            setFilteredCountries(countries);
        }

    }, [search, countries])

    useEffect(() => {
        const country = countries.find(val => val?.three_letter_code?.toLowerCase() === defaultCountry?.toLowerCase())
        setCountry(country || countries[0])
    }, [countries]);

    const handleSelect = (country) => {
        setExpanded(false)
        setCountry(country)
    }
    const handleNext = async () => {
        if (loading) {
            return;
        }
        setLoading(true);
        if (!country) {
            dispatch(showMessageBar(MESSAGE_BAR_TYPES.WARNING, "Country is required!"));
            setLoading(false);
            return;
        } else {
            try {
                logEvent({
                    current: EVENTS.WITHDRAWAL.FIAT_COUNTRY,
                    activity: ACTIVITY_DETAIL.WITHDRAWAL.FIAT_COUNTRY,
                    meta: {
                        data: {
                            country: country.three_letter_code,
                            countryName: country.name,
                            pathname: location.pathname,
                            source: ACTIVITY_DETAIL.WITHDRAWAL.FIAT_COUNTRY
                        }
                    }
                });
                await massPayCreateUser();
                const response = await getMassPayPaymentMethods(country.three_letter_code);
                if (response.result.length === 1) {
                    const paymentMethod = response.result[0];
                    setPaymentMethod(paymentMethod);
                    dispatch(addSkipIndex(active + 1));
                    dispatch(addSkipIndex(active + 2));
                    setPaymentPayer(null);
                    const currenciesResponse = await getCurrencyListFiat(amount, country.three_letter_code, paymentMethod.actualValue);
                    if (currenciesResponse.result?.payers && currenciesResponse.result?.payers?.length) {
                        if (currenciesResponse.result?.payers?.length === 1) {
                            setPaymentPayer(currenciesResponse.result?.payers[0]);
                            setDestinationId(currenciesResponse.result?.payers[0].destinationRecordId);
                            if (currenciesResponse.result?.payers[0].currencySymbols.length === 1) {
                                setPaymentCurrency(currenciesResponse.result?.payers[0].currencySymbols[0]);
                                dispatch(addSkipIndex(active + 3));
                                setActive(active + 4);
                            } else {
                                setActive(active + 3);
                            }
                        } else {
                            dispatch(removeSkipIndex(active + 2))
                            setActive(active + 2);
                        }
                    } else if (currenciesResponse.result.currencySymbols.length === 1) {
                        setPaymentCurrency(currenciesResponse.result.currencySymbols[0]);
                        setDestinationId(currenciesResponse.result.destinationRecordId);
                        dispatch(addSkipIndex(active + 3));
                        setActive(active + 4);
                    } else {
                        dispatch(removeSkipIndex(active + 3))
                        setActive(active + 3);
                    }
                } else {
                    dispatch(removeSkipIndex(active + 1))
                    setActive(active + 1);
                }
                // check if payment method is 1 if yes active  + 2 or active + 1
                // setActive(active + 1);
                setLoading(false);
            } catch (err) {
                dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
                setLoading(false);
            }
        }
    }
    const handleChange = (_, isExpanded) => {
        setExpanded(isExpanded);
    };
    const handleSearchChange = (ev) => {
        setSearch(ev.target.value)
    }

    if (!countries || !countries.length) {
        return <AppScreenLoader />
    }
    return (<Paper
        sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: 1,
        }}>
        <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} height={height}>
            <Box>
                <Accordion expanded={expanded} defaultExpanded={false} onChange={handleChange}>
                    <AccordionSummary
                        expandIcon={<IconButton onClick={() => setExpanded(!expanded)} aria-label="tracker"
                            aria-describedby="country_list_expand">
                            <ExpandMore aria-label="tracker"
                                aria-describedby="country_list_expand" />
                        </IconButton>}

                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        {!expanded && <InputBase
                            value={country?.name || ""}
                            autoFocus={true}
                            size="sm"
                            disabled
                            fullWidth
                            name="country"
                        />}
                        {expanded && <InputBase
                            value={search}
                            autoFocus={true}
                            autoComplete="new-password"
                            onChange={handleSearchChange}
                            // onBlur={() => setExpanded(false)}
                            size="sm"
                            placeholder={expanded ? "Search" : ""}
                            fullWidth
                            name="search"
                        />}
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: 0, minHeight: height, maxHeight: height }}>
                        {!!filteredCountries.length && <MenuList sx={{ overflowY: 'auto', maxHeight: 'inherit', marginTop: 2 }} disablePadding >
                            {filteredCountries.map((value, index) => (
                                <MenuItem
                                    key={index}
                                    onClick={() => handleSelect(value)}
                                    sx={{ color: '#F8FAFF', fontFamily: 'Manrope', textTransform: 'capitalize' }}
                                    disableGutters
                                >
                                    <Radio checked={value.three_letter_code === country.three_letter_code} checkedIcon={<RadioButtonChecked sx={{ color: '#0088F5' }} />} />
                                    <Typography>{value.name}</Typography>
                                </MenuItem>))}
                        </MenuList>}
                        {!(filteredCountries.length) && <Box>
                            <Typography padding={2}>Country is not available!</Typography>
                        </Box>}
                    </AccordionDetails>
                </Accordion>
            </Box>
            <AppButton
                loading={loading}
                buttontheme={'light'}
                onClick={handleNext}
                type="submit"
                title={t("nextStep")}
            />
        </Box>

    </Paper>)
}

CountrySelect.propTypes = {
    amount: PropTypes.any,
    setActive: PropTypes.func,
    active: PropTypes.number,
    setShowKytBlocked: PropTypes.func,
    setShowKyt: PropTypes.func,
    country: PropTypes.any,
    setCountry: PropTypes.func
}